<div class="container clear-to-apply-container">
  <div *ngIf="contentData" class="float-left bg-white card-background-fullwidth">
    <form [formGroup]="clearToApplyForm" autocomplete="off" role="form" class="fieldHeight" *ngIf="clearToApplyForm">
      <div class="row">
        <app-content-top-nav [parentElement]="el" [parentFormToValidate]="clearToApplyForm"
          [visibleBackNav]='isHOView ? false : true ' [enableBackNav]='true' (onBackClickHandler)="goBack()">
        </app-content-top-nav>
      </div>
      <div class="row">
        <div class="col-md-12 clear-all title-inner-container">
          <h1 class="custom-header-h2 responsive-text-8" id="beforeYouStart-header">{{contentData.header}}</h1>
        </div>
      </div>
      <div class="content-container">
        <div class="row">
          <div class="col-md-12">
            <p class="content-top mt-0" id="beforeYouStart-introduction">{{contentData.introduction}}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 inner-content-container bg-lightblue mar-lr-0">
            <p class="inner-content-data" id="string_PensionWiseTitle">{{contentData.string_PensionWiseTitle}}</p>
            <p class="inner-content-data" id="string_PensionWiseCopy">{{contentData.string_PensionWiseCopy}}</p>
          </div>
        </div>

        <div class="data-container">
          <div class="row">
            <app-question (pensionCreditEmitter)="pensionCreditReceiver($event)" [childId]="'bankruptQuestionary'"
              [questionConfig]="contentData.bankruptQuestion" [parent]="clearToApplyForm" [controlName]="'bankrupt'"
              (onDisplayMobileTooltipEmitter)="displayTooltipMessage('bankrupt')">
            </app-question>
          </div>

          <div class="row">
            <app-question (benefitGuaranteedEmitter)="benefitGuaranteedReceiver($event)"
              [childId]="'pension-policyQuestionary'" [questionConfig]="contentData.pensionPolicyQuestion"
              [parent]="clearToApplyForm" [controlName]="'pensionPolicy'"
              (onDisplayMobileTooltipEmitter)="displayTooltipMessage('pensionPolicy')">
            </app-question>
          </div>

        </div>
      </div>
      <div class="col-md-12 clear-all bottom-container">
        <div class="float-left">
          <app-save [parentElement]="el" [parentFormToValidate]="clearToApplyForm" [location]="'contentBottom'"></app-save>
        </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="userInputDetail['buttonConfig']"
            [buttonType]="'normalCTA'"></app-content-bottom-nav>
        </div>
      </div>
      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeModal()"
        (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
        [tooltipFlag]="true"></app-modal>
    </form>
  </div>

</div>